import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from "./views";

export const TemplateHeader = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Header textColor='textSecondary'>
      <Layout.HeaderContent>
        <Layout.Logo>
          {template.logo.src ? (
            <Layout.LogoImage src={template.logo.src} />
          ) : (
            <Layout.LogoText fontFamily={template.logo.fontFamily}>
              {template.logo.text}
            </Layout.LogoText>
          )}
        </Layout.Logo>
        <Layout.Menu
          hasShoppingCart={template.sections.navigation.hasShoppingCart}
        />
      </Layout.HeaderContent>
    </Layout.Header>
  )
}

const CareerService = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Container className="select-none pointer-events-none">
      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage} afterBackgroundColor="#00000060" textColor="textSecondary">
        <Layout.HeroContainer>
          <TemplateHeader />
          <Layout.Content>
            <Layout.HeroTitle>{template.sections.hero.title}</Layout.HeroTitle>
            <Layout.HeroDescription>{template.sections.hero.subtitle}</Layout.HeroDescription>
            <Layout.CTA 
              variant="contained" // Contained style for the button
              backgroundColor="textSecondary"    // Background color as secondary
              textColor="primary" // Text color is the default text color (not light text)
            >
              {template.sections.hero.ctaText}
            </Layout.CTA>
          </Layout.Content>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout.Container>
  );
};

export default CareerService;
